import React, { ReactNode } from 'react';
import { getDMPositionDetailPath } from 'routing/paths';
// components
import Link from '@material-ui/core/Link';
import { CustomLink } from 'components/Links';

interface Props {
  zoneId: number;
  levelId: number;
  groupId: number;
  positionId: number;
  children: ReactNode;
  withReturnUrl?: boolean;
}

export const PositionDetailLink = (props: Props): JSX.Element => {
  const { zoneId, levelId, groupId, positionId, withReturnUrl, children } = props;

  return (
    <Link
      component={ CustomLink }
      color="secondary"
      to={ getDMPositionDetailPath(zoneId, levelId, groupId, positionId) }
      withReturnUrl={ withReturnUrl }
    >
      { children }
    </Link>
  );
};
